import { riskMapConfigs } from "./riskMap/RasterTile";
export const rasterTileRegistry = {
  ...riskMapConfigs,
};
